export default __webpack_public_path__ + "static/media/lol-cover.c6495149.png";